<template>
  <router-link 
    class="BtnExtend"
    :to="{name: extend ? 'project-extended' : 'project-beknopt', params: { slug }}"
    :class="classList">
    A
  </router-link>
</template>

<script>
export default {
  name: 'BtnExtend',
  props: {
    extend: {
      type: Boolean,
      default: false
    },
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    classList() {
      return {
        'BtnExtend--extend' : this.extend
      }
    }
  }
}
</script>

<style lang="scss">
  .BtnExtend {

    display: none; // z-index related issue

    position: absolute;
    width: 20px;
    height: 64px;
    top: 48px;
    right: 800px;
    border: 1px solid #979797;
    border-right-width: 0;
    background: #D8D8D8;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    cursor: pointer;
    user-select: none;
    opacity: 0.99;
    z-index: 999999999999;

    &--extend {
      right: 480px;
    }
  }
</style>
